function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { Html, Image } from "@custom/schema";
import clsx from "clsx";
import React, { useEffect, useRef } from "react";
import ArrowLink from "../molecules/ArrowLink";
import { FadeUp } from "../molecules/FadeUp";
export default function TextImageBlock(props) {
    var _props_textImageSection;
    var observerRef = useRef(null);
    useEffect(function() {
        var currentVisibleElement = null;
        observerRef.current = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var isIntersecting = entry.isIntersecting, intersectionRatio = entry.intersectionRatio, target = entry.target;
                if (isIntersecting && intersectionRatio >= 1) {
                    if (currentVisibleElement !== target) {
                        if (currentVisibleElement) {
                            currentVisibleElement.style.opacity = "0.15";
                        }
                        target.style.opacity = "1";
                        currentVisibleElement = target;
                    }
                }
            });
        }, {
            threshold: 1
        });
        var fadeElements = document.querySelectorAll(".fade-element");
        fadeElements.forEach(function(element, index) {
            var _observerRef_current;
            (_observerRef_current = observerRef.current) === null || _observerRef_current === void 0 ? void 0 : _observerRef_current.observe(element);
            // Set opacity to 1 for the first item
            if (index === 0) {
                element.style.opacity = "1";
                currentVisibleElement = element;
            }
        });
        return function() {
            var _observerRef_current;
            (_observerRef_current = observerRef.current) === null || _observerRef_current === void 0 ? void 0 : _observerRef_current.disconnect();
        };
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("px-6 md:px-14 pb-3 mt-20 md:mt-24 lg:mt-28", {
            "bg-gradient-to-b from-white to-[#F7F9FB]": !props.scrollable,
            "mb-14 md:mb-24 lg:mb-28": props.scrollable,
            "md:pb-14": props.largeImages || props.scrollable,
            "md:pb-28": !props.largeImages && !props.scrollable
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("mx-auto", {
            "max-w-4xl": !props.largeImages,
            "max-w-5xl": props.largeImages
        })
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "text-2xl md:text-3xl lg:text-4xl block mx-auto text-center mb-6 md:mb-11 lg:mb-14"
    }, props.heading), /*#__PURE__*/ React.createElement("div", {
        className: ""
    }, (_props_textImageSection = props.textImageSection) === null || _props_textImageSection === void 0 ? void 0 : _props_textImageSection.map(function(section, key) {
        var imageAlignment = key % 2 === 0 ? props.alternatingImageAlignment : props.alternatingImageAlignment === "left" ? "right" : "left";
        return /*#__PURE__*/ React.createElement("div", {
            key: key,
            className: clsx("", {
                "md:mb-20 md:last:mb-0": !props.largeImages
            })
        }, /*#__PURE__*/ React.createElement(TextImageSection, _object_spread_props(_object_spread({}, section), {
            scrollable: props.scrollable,
            largeImages: props.largeImages,
            largeFont: props.largeFont,
            childDelay: key === 0 ? 0.1 : 0.4,
            imagePosition: imageAlignment
        })));
    }))));
}
function TextImageSection(param) {
    var image = param.image, heading = param.heading, subheading = param.subheading, imagePosition = param.imagePosition, content = param.content, target = param.target, label = param.label, scrollable = param.scrollable, childDelay = param.childDelay, largeImages = param.largeImages, largeFont = param.largeFont;
    return /*#__PURE__*/ React.createElement(FadeUp, {
        yGap: 0,
        elDelay: childDelay,
        disable: !scrollable
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:flex w-full lg:gap-x-14 items-center justify-center mb-11 md:mb-12 lg:mb-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("mx-auto mb-6 md:mb-12 lg:m-0", {
            "max-w-[80%] md:max-w-md lg:max-w-[50%]": largeImages,
            "max-w-[250px] tib-wrapper": !largeImages
        })
    }, image ? /*#__PURE__*/ React.createElement(Image, {
        source: image,
        className: "mx-auto md:m-0",
        alt: "".concat(heading)
    }) : null), /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "lg:order-first": imagePosition === "right",
            "lg:max-w-[590px]": !largeImages && image
        })
    }, /*#__PURE__*/ React.createElement("h3", {
        className: clsx("", "text-xl md:text-2xl lg:text-[1.7rem] font-semibold", {
            "md:mb-2": subheading,
            "mt-7 mb:mt-0 mb-5": !subheading
        })
    }, heading), subheading ? /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-200 block mb-4 md:mb-8"
    }, subheading) : null, content ? /*#__PURE__*/ React.createElement("div", {
        className: clsx("content-text content-text-sm", {
            "text-[0.85rem]": !largeFont
        })
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: content
    })) : null, target ? /*#__PURE__*/ React.createElement("div", {
        className: "border-t border-t-gray-400 pt-5 mt-7"
    }, /*#__PURE__*/ React.createElement(ArrowLink, {
        text: label ? label : "Learn more",
        target: target
    })) : null)));
}
